// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  background-color: #EFEFEF;
}

.alinhamento {
  margin-top: 50px !important;
}

.bg-verde {
  background-color: #50B848;
}

.img-logo {
  width: 82px;
  height: auto;
}

.loading-auto {
  display: block;
  width: 80%;
  max-width: 200px;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/routes/pages/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;AACF;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,yBAAA;AADF;;AAIA;EACE,WAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AADF","sourcesContent":[".wrapper {\n  background-color: #EFEFEF;\n  //background-image: url(\"../../../../assets/img/background_blur.jpg\");\n  //background-size: cover;\n  //background-repeat: no-repeat;\n}\n.alinhamento {\n  margin-top: 50px !important;\n}\n\n.bg-verde {\n  background-color: #50B848;\n}\n\n.img-logo {\n  width: 82px;\n  height: auto;\n}\n\n.loading-auto {\n  display: block;\n  width: 80%;\n  max-width: 200px;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
